import { useEffect, useState } from 'react';
import type { AdminOverview, AdminUserRow } from '@gc/shared';
import { api } from '../lib/api.js';

/** Статистика по всем ученикам. Открывается только тем, кто есть в ADMIN_IDS. */
export function Admin(): JSX.Element {
  const [overview, setOverview] = useState<AdminOverview | null>(null);
  const [users, setUsers] = useState<AdminUserRow[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void (async () => {
      try {
        const [o, u] = await Promise.all([api.adminOverview(), api.adminUsers()]);
        setOverview(o);
        setUsers(u);
      } catch (e) {
        setError(e instanceof Error ? e.message : 'Не удалось загрузить статистику');
      }
    })();
  }, []);

  if (error) return <div className="screen"><p className="error">{error}</p></div>;
  if (!overview) return <div className="screen"><p className="hint">Загружаю…</p></div>;

  // Показываем только те дни, на которых кто-то стоит: полный список из 22
  // строк с нулями ничего не сообщает.
  const stuck = overview.byDay.filter((d) => d.reached > 0);

  return (
    <div className="screen">
      <div className="card">
        <h2>Все ученики</h2>
        <div className="stats">
          <div><span className="big mono">{overview.users}</span><span className="dim">всего</span></div>
          <div><span className="big mono">{overview.activeToday}</span><span className="dim">сегодня</span></div>
          <div><span className="big mono">{overview.activeWeek}</span><span className="dim">за неделю</span></div>
          <div><span className="big mono">{overview.finished}</span><span className="dim">закончили</span></div>
        </div>
      </div>

      {stuck.length > 0 && (
        <div className="card">
          <h3>Кто на каком дне</h3>
          <ul className="bullets">
            {stuck.map((d) => (
              <li key={d.day}>
                День {d.day} — {d.title}: {d.reached}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="card">
        <h3>Ученики</h3>
        <div className="tabgrid">
          <table className="users">
            <thead>
              <tr>
                <th>Кто</th>
                <th>Пройдено</th>
                <th>День</th>
                <th>Серия</th>
                <th>Последнее</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.name}{u.username ? ` @${u.username}` : ''}</td>
                  <td className="mono">{u.completed}</td>
                  <td className="mono">{u.currentDay ?? '—'}</td>
                  <td className="mono">{u.streak}</td>
                  <td className="mono">{u.lastDate ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
